import cornerstone from "cornerstone-core";
import { useViewerContext } from "pages/viewer/context/viewer.context";
import { VIEWPORT_STATUSES } from "pages/viewer/dicomViewer.consts";
import { useCallback, useEffect, useMemo } from "react";

export const useAxialImages = () => {
  const {
    dispatch,
    state: { viewports, isMPRActive, axialImages },
  } = useViewerContext();

  const imageIds = useMemo(
    () => (viewports.length && viewports[0].frames ? viewports[0].frames : []),
    [viewports]
  );
  const loadAxialImages = useCallback(async () => {
    dispatch({
      type: "SET_MPR_VIEWPORT_STATUSES",
      payload: { updatedStatus: VIEWPORT_STATUSES.LOADING_AXIAL_IMAGES },
    });
    const loadAxialImages = Promise.all(
      imageIds.map((imageId) => cornerstone.loadAndCacheImage(imageId))
    );
    const loadedAxialImages = await loadAxialImages.then((images) => images);
    dispatch({
      type: "LOAD_AXIAL_IMAGES",
      payload: { axialImages: loadedAxialImages },
    });
    dispatch({
      type: "SET_MPR_VIEWPORT_STATUSES",
      payload: { updatedStatus: VIEWPORT_STATUSES.RECONSTRUCTING_IMAGES },
    });
  }, [imageIds, dispatch]);

  useEffect(() => {
    if (isMPRActive && axialImages.length === 0) {
      loadAxialImages();
    }
  }, [loadAxialImages, isMPRActive]);
};
